/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Descriptionfallback1Inputs */

const ja_metadata_descriptionfallback1 = /** @type {(inputs: Metadata_Descriptionfallback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN（株式会社プレイブレーン）は東京を拠点とするゲームマーケティング・eスポーツ制作会社です。日本・アジア市場に加え、欧米市場への展開も支援しています。`)
};

const en_metadata_descriptionfallback1 = /** @type {(inputs: Metadata_Descriptionfallback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN is a Tokyo-based game marketing agency helping publishers and gaming brands grow across Japan and Asia through marketing, esports production, creative, and digital experiences.`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN is a Tokyo-based game marketing agency helping publishers and gaming brands grow across Japan and Asia through marketing, esports production, creat..." |
*
* @param {Metadata_Descriptionfallback1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const metadata_descriptionfallback1 = /** @type {((inputs?: Metadata_Descriptionfallback1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Descriptionfallback1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_descriptionfallback1(inputs)
	return en_metadata_descriptionfallback1(inputs)
});
export { metadata_descriptionfallback1 as "metadata_descriptionFallback" }